import { Injectable } from '@angular/core';
import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import { PgLinearLoaderFactoryComponent } from 'projects/grit-core/src/lib/pg-linear-loader/pg-linear-loader-factory/pg-linear-loader-factory.component';

@Injectable()
export class StartLoaderBehavior extends StrictBehavior {
  static readonly DESCRIPTION = 'The behavior to start a loader on the page';

  static readonly GLOBAL_OUTPUT_PROPS = {};

  static readonly GLOBAL_INPUT_PROPS = {};

  static readonly VERSION = '1.0.0';

  static readonly ARGS = {
    loaderId: {
      required: true,
      name: 'loaderId',
      type: 'string',
      description: 'The loader id',
    },
  };

  async executeBehavior(
    args: { loaderId: string },
    ctx: BehaviorContext
  ): Promise<any> {
    const loaderFactory: PgLinearLoaderFactoryComponent = ctx.getFactoryById(
      args.loaderId
    );
    loaderFactory.linearLoader.hidden = false;
    ctx.set(`loaderStartTime-${args.loaderId}`, new Date());
  }
}
